import { render } from "./G01ItemList.vue?vue&type=template&id=03f2b2c1&scoped=true&ts=true"
import script from "./G01ItemList.vue?vue&type=script&lang=ts"
export * from "./G01ItemList.vue?vue&type=script&lang=ts"

import "./G01ItemList.vue?vue&type=style&index=0&id=03f2b2c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f2b2c1"]])

export default __exports__